import BaseRequest from './BaseRequest';

/**
 * One bootstrap call: the module map plus towns, categories and tags. The app
 * does not render a route until this lands, because `features` decides which
 * routes exist.
 */
class ConfigRequests extends BaseRequest {
  REQUEST_TYPE = 'CONFIG';

  endpoint = '/api/config';

  fetch({ label = '', onSuccess, onFailure }) {
    return this.apiAction({
      url: this.getEndpoint(),
      onSuccess,
      onFailure,
      label: this.getLabel(label, 'GET'),
    });
  }
}

export default ConfigRequests;
